import { getRunningBuildVersion } from "./buildVersion";

const RELOAD_KEY_PREFIX = "chunkReloadFor:";

const CHUNK_ERROR_PATTERN =
  /Loading chunk|Loading CSS chunk|ChunkLoadError|dynamically imported module|Importing a module script failed|Unexpected token '<'/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const err = error as { name?: string; message?: string };
  if (err.name === "ChunkLoadError") return true;
  return CHUNK_ERROR_PATTERN.test(String(err.message || error));
}

function isAppAsset(url: string): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.href);
    if (parsed.origin !== window.location.origin) return false;
    return /\.(?:bundle\.js|css)$/.test(parsed.pathname);
  } catch (e) {
    return false;
  }
}

export function reloadOnceForChunkError(): boolean {
  const key = RELOAD_KEY_PREFIX + (getRunningBuildVersion() || "unknown");

  try {
    if (window.sessionStorage.getItem(key) === "1") return false;
    window.sessionStorage.setItem(key, "1");
  } catch (e) {
    return false;
  }

  window.location.reload();
  return true;
}

export function installChunkErrorListeners(): void {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "error",
    event => {
      const target = event.target as HTMLElement | null;

      if (target instanceof HTMLScriptElement) {
        if (isAppAsset(target.src)) reloadOnceForChunkError();
        return;
      }
      if (target instanceof HTMLLinkElement) {
        if (isAppAsset(target.href)) reloadOnceForChunkError();
        return;
      }
      if (isChunkLoadError((event as ErrorEvent).error)) {
        reloadOnceForChunkError();
      }
    },
    true
  );

  window.addEventListener("unhandledrejection", event => {
    if (isChunkLoadError(event.reason)) reloadOnceForChunkError();
  });
}
